
    import Vue from 'vue'
    import { home } from '../config/home'
    import router from "../router";
    import ReziseSensor from "css-element-queries/src/ResizeSensor";
    import VuePlotly from '@statnett/vue-plotly'
    export default Vue.extend({
        name: 'Contact',
        metaInfo: {
            title: 'QDRA',
            meta : [
                {
                    name: 'description',
                    content : 'Thunderstorms and Cyclones are a part of life in Australia. The Queensland Disaster Research Alliance (QDRA) is a state-based University collaboration that aims to grow and integrate Queensland’s capability and capacity to deliver high impact and at-scale disaster management research outcomes for the state, nationally and internationally.'
                },
                {
                    name: 'keywords',
                    content : 'cyclones, thunderstorms, disasters, floods, fires, Australia, Queensland, houses, storm preparation, cyclone, weather, storm, protection, collaboration, disaster management, research, education'
                }
            ]
        },

        data: () => ({
            valid: true,
            valid1: true,
            name: '',
            nameRules: [
                (value: any ) => {
                    if (value) return true

                    return 'Name is requred.'
                },

            ],
            email: '',
            emailRules: [
                (value: any ) => {
                    if (value) return true

                    return 'E-mail is requred.'
                },
                (value: string ) => {
                    if (/.+@.+\..+/.test(value)) return true

                    return 'E-mail must be valid.'
                },
            ],
            phone: '',
            phoneRules: [
                (value: any ) => {
                    if (value) return true

                    return 'Phone number is requred.'
                },
            ],

            msg: '',
            msgRules: [
                (value: any ) => {
                    if (value) return true

                    return 'Message is requred.'
                },
                (value: any ) => {
                    if (value.length <= 250) return true

                    return 'Name must be less than 250 characters.'
                },
            ],

        }),
        methods: {

        },
        computed: {

        },
    })
